import React from 'react';
import { IAppComponentProps } from 'src/components';

const MasterDataInfoPortalTabComponent: React.FC<IAppComponentProps> = (props) => {
    return (
        <div>
            <h1>Master Data Info Portal Tab</h1>
            <p>This is the Master Data Info Portal Tab component.</p>
        </div>
    );
};

export default MasterDataInfoPortalTabComponent;